import { render, staticRenderFns } from "./access-facebook-ads.vue?vue&type=template&id=2194b33c&scoped=true"
import script from "./access-facebook-ads.vue?vue&type=script&lang=js"
export * from "./access-facebook-ads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2194b33c",
  null
  
)

export default component.exports